export default __webpack_public_path__ + "efbbb6de05b875fc6c028c5f74692c3a.png";